import {useMapContext} from '@/components/MindMap/index.mjs'
import MenuButton from '../MenuButton.jsx'

export default function MenuButtonSaveProduct(props) {
    const map = useMapContext()

    if (! map.permission.has('write')) {
        return null
    }

    return (
        <MenuButton
            onClick={() => map.save()}
            {...props}
        >
            保存
        </MenuButton>
    )
}
